import Vue from 'vue'
import Vuex from 'vuex'
import * as ACTIONS from '../actions'
import * as MUTATIONS from '../mutations'
import API from '../../services/api'
import URL from 'url'

Vue.use(Vuex)

export default {
	state: {
		list: [],
		count: 0,
		current: null,
		recent: [],
	},
	mutations: {
		[MUTATIONS.POST.LIST](state, list) {
			state.list = list
		},
		[MUTATIONS.POST.RECENT](state, list) {
			state.recent = list
		},
		[MUTATIONS.POST.ADD_LIST](state, list) {
			const l = [...state.list].concat(list)
			state.list = l
		},

		[MUTATIONS.POST.UPDATE_IMAGE](state, { postId, image }) {
			let result = state.list.find(p => {
				return p.id === postId
			})

			const idx = state.list.indexOf(result)

			if (idx > -1) {
				result.image = image
				result.imageLoaded = true
				Vue.set(state.list, idx, result)
			}
		},

		[MUTATIONS.POST.COUNT](state, count) {
			state.count = count
		},
		[MUTATIONS.POST.CURRENT](state, post) {
			state.current = post
		},

		[MUTATIONS.POST_CATEGORY.UPDATE](state, postToPostCategory) {
			let post = state.list.find(p => {
				return p.id === postToPostCategory.postId
			})

			const idx = state.list.indexOf(post)

			if (idx > -1) {
				post.ptpcId = postToPostCategory.id
				post.categoryAId = postToPostCategory.postCategoryId
				post.categoryBId = postToPostCategory.postSubCategoryId
				Vue.set(state.list, idx, post)
			}
		},
	},
	actions: {
		[ACTIONS.POST.RECENT]({ commit }, { filter = {} }) {
			return API.POST.LIST(filter).then(res => {
				res.forEach(post => {
					// eslint-disable-next-line node/no-deprecated-api
					post.image = URL.resolve('https://storage.googleapis.com', post.image)
				})

				commit(MUTATIONS.POST.RECENT, res)
				return res
			})
		},
		[ACTIONS.POST.BY_ID]({ commit, dispatch, state }, { id, filter = {} }) {
			return API.POST.BY_ID(id, filter).then(res => {
				// eslint-disable-next-line node/no-deprecated-api
				res.image = URL.resolve('https://storage.googleapis.com', res.image)
				commit(MUTATIONS.POST.CURRENT, res)
				return res
			})
		},
		[ACTIONS.POST.EXPORT]({ commit, dispatch, state }, { filter }) {
			return API.POST.EXPORT(filter).then(res => {
				// eslint-disable-next-line node/no-deprecated-api
				return res
			})
		},
		[ACTIONS.POST.BY_DETAIL_ID](
			{ commit, dispatch, state },
			{ filter, append = false },
		) {
			return API.POST.LIST(filter).then(res => {
				res.forEach(post => {
					if (post.image) {
						// eslint-disable-next-line node/no-deprecated-api
						post.image = URL.resolve(
							'https://storage.googleapis.com',
							post.image,
						)
					}
					// eslint-disable-next-line node/no-deprecated-api
				})

				if (append) {
					commit(MUTATIONS.POST.ADD_LIST, res)
				} else {
					commit(MUTATIONS.POST.LIST, res)
				}

				return res
			})
		},
		[ACTIONS.POST.FETCH_POST_BY_DETAIL_ID](
			{ commit, dispatch, state },
			{ filter, append = false },
		) {
			return API.POST.LIST(filter).then(res => {
				res.forEach(post => {
					if (post.image) {
						// eslint-disable-next-line node/no-deprecated-api
						post.image = URL.resolve(
							'https://storage.googleapis.com',
							post.image,
						)
					}
					// eslint-disable-next-line node/no-deprecated-api
				})
				return res
			})
		},
		[ACTIONS.POST.COUNT]({ commit, dispatch, state }, filter = {}) {
			return API.POST.COUNT(filter).then(res => {
				commit(MUTATIONS.POST.COUNT, res.count)
				return res.count
			})
		},
		[ACTIONS.POST.RANK]({ commit, dispatch, state }, { detailId, code }) {
			return API.POST.RANK({ detailId, code }).then(res => {
				return res
			})
		},
		[ACTIONS.POST.EVOLUTION]({ commit, dispatch, state }, filter = {}) {
			return API.POST.EVOLUTION(filter).then(res => {
				return res
			})
		},
		[ACTIONS.POST_CATEGORY.UPDATE]({ commit, dispatch, state }, category) {
			return API.POST_CATEGORY.UPDATE({
				id: category.id,
				postId: category.postId,
				postCategoryId:
					category.postCategoryId === 0 ? null : category.postCategoryId,
				postSubCategoryId:
					category.postSubCategoryId === 0 ? null : category.postSubCategoryId,
			}).then(res => {
				commit(MUTATIONS.POST_CATEGORY.UPDATE, res)
				return res
			})
		},
		[ACTIONS.POST.TOP]({ commit, dispatch, state }, filter = {}) {
			return API.POST.TOP(filter).then(res => {
				return res
			})
		},
		[ACTIONS.POST.POST_TYPE]({ commit, dispatch, state }, filter = {}) {
			return API.POST.POST_TYPE(filter).then(res => {
				return res
			})
		},
	},

	getters: {
		getPosts: state => state.list,
		getPostsTotalCount: state => state.count,
		getPostCurrent: state => state.current,
		getPostsRecent: state => state.recent,
	},
}
